// pages/index.js

import Head from "next/head";
import Script from "next/script";
import dynamic from "next/dynamic";
import MetaTags from "@/components/MetaTags";
import orgSchema from "@/utils/OrgJsonLd";
import AiChat from "@/components/home/ai-chat";
const Hero = dynamic(() => import("./new-home/_components/hero"));


// add dynamic imports:
const WebDesign = dynamic(() => import("@/components/home/WebDesign"));
const VIP = dynamic(() => import("@/components/home/VIP"));
const SEO = dynamic(() => import("@/components/home/SEO"));
const GoogleAds = dynamic(() => import("@/components/home/GoogleAds"));
const SocialMedia = dynamic(() => import("@/components/home/SocialMedia"));
const EmailMarketing = dynamic(
  () => import("@/components/home/EmailMarketing"),
);

export default function Home() {
  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
        <meta
          name="google-site-verification"
          content="Th0T77uU3ev_EaoatFmcuZpF290R3RE0dxx0GdJdIpA"
        />
      </Head>
      <Script id="facebook-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1723876454548423');
          fbq('track', 'PageView');
          fbq('track', 'ViewContent');
        `}
      </Script>
      <MetaTags
        pageTitle="Ventura Web Design & Marketing"
        pageDescription="Ventura Web Design & Marketing is a full-service digital agency that specializes in building and marketing ecommerce websites."
        path="/"
        isHome={true}
      />

     <Hero />

      {/* <Hero /> */}
      <AiChat />
      <WebDesign />
      <VIP />
      <SEO />
      <GoogleAds />
      <SocialMedia />
      <EmailMarketing />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {},
    revalidate: false,
  };
}
